import {createBrowserRouter, RouterProvider} from "react-router-dom";
import routes from "./routes";
import {AlertProvider} from "./util/AlertContext";
import * as Sentry from "@sentry/react";

export default function App() {
    const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
    const selfcareRouter = sentryCreateBrowserRouter(routes);
    return (
        <AlertProvider>
            <RouterProvider router={selfcareRouter}/>
        </AlertProvider>
    )
}



